"use client";
import React from "react";
import continueVerify from "@/public/images/done.svg";
import Image from "next/image";
import Link from "next/link";
import MyLink from "@/components/shared/myLink/MyLink";
const index = ({
  step,
  setstep,
}: {
  step?: number;
  setstep?: React.Dispatch<React.SetStateAction<number>>;
}) => {
  return (
    <div className=" flex items-center justify-center">
      <div className=" bg-[#232c37] p-5 md:py-[30px] md:px-[40px] rounded-[10px] w-fit flex flex-col gap-4 items-center justify-center ">
        <Image
          src={continueVerify}
          alt="continueVerify"
          // className=" -mt-16 lg:-mt-28"
        />
        <p className=" text-40 text-white font-[500] text-center ">
          {/* جاري تفعيل حسابك */}
          تم انشاء حسابك بنجاح
        </p>
        <p className=" text-16 text-textColor ">يمكنك تسجيل الدخول الان</p>
        <MyLink href={"/login"}>
          <p
            className=" text-13 font-500 text-white py-2 px-5 border border-white
                rounded-[7px] bg-gradient-to-b from-[#232c3727] to-[#232c3766]"
          >
            تسجيل الدخول
          </p>
        </MyLink>
      </div>
    </div>
  );
};

export default index;
